var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdai(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 256c70.692 0 128-57.308 128-128C256 57.308 198.692 0 128 0 57.308 0 0 57.308 0 128c0 70.692 57.308 128 128 128Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.904 106.88h-15.191c-8.361-23.209-30.848-39.127-60.503-39.127H79.442v39.127H62.505v14.039h16.937v14.72H62.505v14.034h16.937v38.656h48.768c29.312 0 51.625-15.785 60.201-38.656h15.488v-14.039h-12.073a63.81 63.81 0 0 0 .471-7.593v-.343c0-2.304-.128-4.567-.343-6.784h11.991v-14.039l-.041.005ZM93.097 80.256h35.113c21.76 0 37.929 10.711 45.399 26.583H93.097V80.256Zm35.113 95.447H93.097v-26.071h80.425c-7.506 15.616-23.634 26.071-45.312 26.071Zm49.961-47.36a50.46 50.46 0 0 1-.512 7.255H93.097v-14.72h84.608c.31 2.363.467 4.744.471 7.127l-.005.338Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85C14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B150"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h256v256H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdai);
export default __webpack_public_path__ + "static/media/sdai.8c1a8d0b96824ca6dd618d4b797c941f.svg";
export { ForwardRef as ReactComponent };